//React
import React from 'react'
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as myProofAction from '../action/myProofAction';
import * as helpAction from '../action/helpAction';
import * as guideAction from '../action/guideAction';
//Material-ui
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
//Icon
import DeleteIcon from '@material-ui/icons/Delete';

//Part
import PartPageTitle from './PartPageTitle';

//Dialog
import DialogConfirm from './DialogConfirm';


class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      proofDelType: null,
    }
  }

  componentDidMount() {
    document.title = '証明書 - パートナーズ';
    window.scrollTo(0, 0);
  };


  _proofDelSubmit() {
    this.props.myProofDel(this.state.proofDelType);
    this.setState({proofDelType: null});
  }




  render() {

    return (
      <div style={{maxWidth:'480px', margin:'auto'}}>
        <PartPageTitle
          title={'証明書の編集'}
          onback={'/my/'}
          helpType={ 'category' }
          helpFilter={ 'proof' }
        />

        {
          (this.props.my.profile.userdata_sex === 'men') && (
            <div>
              <div align='center' style={{color:'#666'}}>
                <span className='i-b'>証明書を提出いただくと</span><br/>
                <span className='i-b'>無料メールの1人の方への送信上限が</span>
                <span className='i-b'>最大5通まで増えます</span>
              </div>
              <div align='center'>
                {
                  (this.props.my.proof.person === 1) ? (
                    <h4>
                      現在、無料メールは
                      {
                        (this.props.my.proof.person + this.props.my.proof.photo + this.props.my.proof.income + this.props.my.proof.single + this.props.my.proof.credit)
                      }
                      通送れます
                    </h4>
                  ) : (
                    <h4>
                      本人証明が申請されていない為、無料メールは送れません
                    </h4>
                  )
                }

              </div>
              <div align='center'>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={ () => this.props.guideApproachMailSet(true) }
                >
                  無料メールとは
                </Button>
              </div>
            </div>
          )
        }

        <div style={{margin:'10px'}}>

          <Box boxShadow={2} style={{background:'#FFF',position:'relative',overflow:'hidden'}}>
            <div
              className='ribbon_orange'
              style={{position:'absolute', top:'0px', left:'0px'}}
            >
              必須
            </div>
            <div style={{padding:'15px'}}>
              <div style={{paddingLeft:'30px', display:'flex',flexDirection:'row', justifyContent: 'space-between', alignItems:'center'}}>
                <h2>
                  本人証明
                </h2>
                <div>
                  {
                    (this.props.my.proof.person === 1) ? (
                      <div>
                        <span className='orange_icon'>提出済み</span>
                        <IconButton
                          onClick={ () => this.setState({proofDelType: 'person'}) }
                        >
                          <DeleteIcon />
                        </IconButton>
                      </div>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        style={{fontSize:'1em'}}
                        onClick={ () => this.props.history.push('/my/proof/person') }
                      >
                        提出はコチラ
                      </Button>
                    )
                  }
                </div>
              </div>
              <div style={{color:'#666'}}>
                ご本人様である、プロフィールの年齢が正しい、未成年者ではない事の証明。
              </div>
            </div>
          </Box>
        </div>

        <div style={{margin:'10px'}}>

          <Box boxShadow={2} style={{background:'#FFF',position:'relative',overflow:'hidden'}}>
            <div
              className='ribbon_blue'
              style={{position:'absolute', top:'0px', left:'0px'}}
            >
              任意
            </div>
            <div style={{padding:'15px'}}>
              <div style={{paddingLeft:'30px', display:'flex',flexDirection:'row', justifyContent: 'space-between', alignItems:'center'}}>
                <h2>
                  写真証明
                </h2>
                <div>
                  {
                    (this.props.my.proof.photo === 1) ? (
                      <div>
                        <span className='orange_icon'>提出済み</span>
                        <IconButton
                          onClick={ () => this.setState({proofDelType: 'photo'}) }
                        >
                          <DeleteIcon />
                        </IconButton>
                      </div>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        style={{fontSize:'1em'}}
                        onClick={ () => this.props.history.push('/my/proof/photo') }
                      >
                        提出はコチラ
                      </Button>
                    )
                  }
                </div>
              </div>
              <div style={{color:'#666'}}>
                メイン写真がご本人様のお写真であることの証明 。
                <div>(メイン写真に正面を向いてはっきりとお顔の確認できる画像を掲載されている方のみ)</div>

              </div>
            </div>
          </Box>
        </div>

        <div style={{margin:'10px'}}>
          <Box boxShadow={2} style={{background:'#FFF',position:'relative',overflow:'hidden'}}>
            <div
              className='ribbon_blue'
              style={{position:'absolute', top:'0px', left:'0px'}}
            >
              任意
            </div>
            <div style={{padding:'15px'}}>
              <div style={{paddingLeft:'30px',  display:'flex',flexDirection:'row', justifyContent: 'space-between', alignItems:'center'}}>
                <h2>
                  収入証明
                </h2>
                <div>
                  {
                    (this.props.my.proof.income === 1) ? (
                      <div>
                        <span className='orange_icon'>提出済み</span>
                        <IconButton
                          onClick={ () => this.setState({proofDelType: 'income'}) }
                        >
                          <DeleteIcon />
                        </IconButton>
                      </div>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        style={{fontSize:'1em'}}
                        onClick={ () => this.props.history.push('/my/proof/income') }
                      >
                        提出はコチラ
                      </Button>
                    )
                  }
                </div>
              </div>
              <div style={{color:'#666'}}>
                プロフィールに記載された年収が昨年度の年収と一致していることの証明 。
              </div>
            </div>
          </Box>
        </div>

        <div style={{margin:'10px'}}>
          <Box boxShadow={2} style={{background:'#FFF',position:'relative',overflow:'hidden'}}>
            <div
              className='ribbon_blue'
              style={{position:'absolute', top:'0px', left:'0px'}}
            >
              任意
            </div>
            <div style={{padding:'15px'}}>
              <div style={{paddingLeft:'30px', display:'flex',flexDirection:'row', justifyContent: 'space-between', alignItems:'center'}}>
                <h2>
                  独身証明
                </h2>
                <div>
                  {
                    (this.props.my.proof.single === 1) ? (
                      <div>
                        <span className='orange_icon'>提出済み</span>
                        <IconButton
                          onClick={ () => this.setState({proofDelType: 'single'}) }
                        >
                          <DeleteIcon />
                        </IconButton>
                      </div>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        style={{fontSize:'1em'}}
                        onClick={ () => this.props.history.push('/my/proof/single') }
                      >
                        提出はコチラ
                      </Button>
                    )
                  }
                </div>
              </div>
              <div style={{color:'#666'}}>
                独身者であることの証明。
              </div>
            </div>
          </Box>
        </div>


        <div style={{margin:'10px'}}>
          <Box boxShadow={2} style={{background:'#FFF',position:'relative',overflow:'hidden'}}>
            <div
              className='ribbon_blue'
              style={{position:'absolute', top:'0px', left:'0px'}}
            >
              任意
            </div>
            <div style={{padding:'15px'}}>
              <div style={{paddingLeft:'30px', display:'flex',flexDirection:'row', justifyContent: 'space-between', alignItems:'center'}}>
                <h2>
                  クレジット証明
                </h2>
                <div align='right'>
                  {
                    (this.props.my.profile.userdata_sex === 'men') ? (
                      (this.props.my.proof.credit === 1) ? (
                        <div>
                          <span className='orange_icon'>提出済み</span>
                        </div>
                      ) : (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={ () => this.props.history.push('/setting/charge/') }
                        >
                          クレジット決済<br/>すると付加されます
                        </Button>
                      )
                    ) : (
                      <Button
                        variant="outlined"
                        disabled
                      >
                        女性は完全無料の為<br/>申請できません
                      </Button>
                    )
                  }
                </div>
              </div>
              <div style={{color:'#666'}}>
                クレジットカードの与信に通過している、未成年者ではない事の証明。
              </div>
            </div>
          </Box>
        </div>


        <DialogConfirm
          open={ (this.state.proofDelType) ? true : false }
          title={'証明書の削除'}
          content={'証明書を1件削除してもいいですか？'}
          apply={ () => this._proofDelSubmit() }
          close={ () => this.setState({proofDelType: null}) }
        />
      </div>

    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...myProofAction,
    ...helpAction,
    ...guideAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
